import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface UserProgressState {
  currentLessonProgress: number;
  dayStreak: number;
}

const initialState: UserProgressState = {
  currentLessonProgress: 0,
  dayStreak: 0,
};

export const userProgressSlice = createSlice({
  name: "userProgress",
  initialState,
  reducers: {
    setCurrentLessonProgress: (state, action: PayloadAction<number>) => {
      state.currentLessonProgress = action.payload;
    },
  },
});

export const { 
  setCurrentLessonProgress,
} = userProgressSlice.actions;

export default userProgressSlice.reducer;
